import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const TIRE_SET_WAREHOUSE_LOCATION_EDIT_FORM_SCHEMA = yup.object({
  warehouse: yup
    .object({
      id: yup.string().required("Molimo Vas da odaberete skladište"),
    })
    .nullable()
    .required("Molimo Vas da odaberete skladište"),
});
